import { is } from '@common/is/is'

import sessionStorage from '@apps/sessionStorage/sessionStorage'

import { MODULE_ID_ATTR, SESSION_STORAGE_LEVEL_OPTIONS_KEY } from '../../definitions'

const EXCLUDED_ATTR_NAMES = [
  'class', 'style'
]

/** GamePage/Scene-en található attributúmok lekérése, és modulazonosító, ha van. */
export default function getGameInfos (): string {
  const levelOptions = sessionStorage.get(SESSION_STORAGE_LEVEL_OPTIONS_KEY)

  if (is.string(levelOptions)) {
    return levelOptions
  }

  const gp = (
    /* eslint-disable no-restricted-syntax */
    document.querySelector('sni-game-page') ??
    document.querySelector('sni-game-scene') ??
    document.querySelector('.edu-game-page')
    /* eslint-enable no-restricted-syntax */
  )

  if (!is.instanceOf(gp, HTMLElement)) {
    return ''
  }

  const attributeNames = gp.getAttributeNames().filter((attrName) => !EXCLUDED_ATTR_NAMES.includes(attrName))

  const attributes = attributeNames.map((attrName) => {
    const attrValue = gp.getAttribute(attrName)

    if (is.null(attrValue) || is.empty(attrValue)) {
      return attrName
    }

    return `${ attrName } = "${ attrValue }"`
  })

  // eslint-disable-next-line no-restricted-syntax
  const moduleId = document.querySelector('html')?.getAttribute(MODULE_ID_ATTR)

  if (is.string(moduleId) && !is.empty(moduleId)) {
    attributes.unshift(`${ MODULE_ID_ATTR } = ${ moduleId }`)
  }

  return attributes.join(' | ')
}
